// TagsFilter.jsx
import './TagFilter.scss'
import { MultiSelectDropdown, SecondaryButton, useSessionStorage } from 'ui_kit_qmd'
import { memo, useCallback, useEffect, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import useOutsideClick from 'ui_kit_qmd/src/hooks/UseOutsideClick'
import classNames from 'classnames'
import { useSearchParams } from 'react-router-dom'
import {
  CLEAR_TEXT,
  TAGS_FILTER_DROPDOWN_LABEL,
  tagsFilterOptions,
  VISITS_TAG_FILTER_LOCAL_STORAGE_KEY,
  tableViewOptions,
} from '../../../../utils/constants'
import { getFilterRowAPI } from '../../VisitTools'
import { filterRowTypeAPI, routeParam } from '../../constants'

/**
 * Parses indexed URL parameters into an array.
 * @param {string} filterType - The base name of the filter (e.g., 'DrugScreenStatuses').
 * @param {URLSearchParams} searchParams - The current URL search parameters.
 * @returns {Array<string>} - The array of filter values.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const parseIndexedParams = (filterType, searchParams) => {
  if (!filterType || !searchParams) {
    console.warn('parseIndexedParams: Missing filterType or searchParams')
    return []
  }

  const regex = new RegExp(`^${filterType}\\[(\\d+)\\]$`)
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  const params = []

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  searchParams.forEach((value, key) => {
    const match = key.match(regex)
    if (match) {
      const index = parseInt(match[1], 10)
      if (!isNaN(index)) {
        params[index] = value
      } else {
        console.warn(`parseIndexedParams: Invalid index for key "${key}"`)
      }
    }
  })

  // Remove undefined indices and return a clean array
  // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
  const parsedParams = params.filter((item) => item !== undefined)
  console.log(`Parsed ${filterType}:`, parsedParams)
  return parsedParams
}

/**
 * Sets indexed URL parameters from an array.
 * @param {string} filterType - The base name of the filter (e.g., 'DrugScreenStatuses').
 * @param {Array<string>} values - The array of filter values.
 * @returns {Object} - Key-value pairs representing the parameters to set.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const setIndexedParams = (filterType, values) => {
  if (!filterType || !Array.isArray(values)) {
    console.warn('setIndexedParams: Missing filterType or values is not an array')
    return {}
  }

  const params = {}
  values.forEach((value, index) => {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    params[`${filterType}[${index}]`] = value
  })

  console.log(`Set ${filterType}:`, params)
  return params
}

// Helper function to generate options list with isActive based on selectedTagsListFromSearchParams
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateMultiSelectTagsFilterOptionsList = (tagsList, selectedTagsListFromSearchParams) => {
  if (!tagsList?.length) return []

  console.log('tagsList:', tagsList)
  console.log('selectedTagsListFromSearchParams:', selectedTagsListFromSearchParams)

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return tagsList.map(({ value, id, type }) => ({
    value,
    tagTypeId: id,
    id, // Include the id property
    type: type || 'flag',
    isActive: selectedTagsListFromSearchParams?.includes(id),
  }))
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const TagsFilter = memo(({ loading, tableView, setFilterRow, onCloseFilterSettings }) => {
  const ref = useOutsideClick(onCloseFilterSettings)

  // Initialize useSearchParams to access current query parameters
  const [searchParams, setSearchParams] = useSearchParams()
  console.log('searchParams:', searchParams.toString())
  console.log('setSearchParams:', setSearchParams)

  const [tagsDropdownOptions, setTagsDropdownOptions] = useState([])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [storedSelectedTagsList, setStoredSelectedTagsList, removeStoredSelectedTagsList] = useSessionStorage(
    VISITS_TAG_FILTER_LOCAL_STORAGE_KEY,
    [],
  )

  // Initialize dropdown options based on URL parameters or session storage
  useEffect(() => {
    const parsedIdentityVerificationStatuses = parseIndexedParams(
      filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES,
      searchParams,
    )

    const parsedDrugScreenStatuses = parseIndexedParams(filterRowTypeAPI.DRUG_SCREEN_STATUSES, searchParams)

    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    const activeFlags = []
    tagsFilterOptions
      .filter((option) => option.type === 'flag')
      .forEach(({ id }) => {
        if (searchParams.get(id) === 'true') {
          activeFlags.push(id)
        }
      })

    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    const combinedParsedFilters = [...parsedIdentityVerificationStatuses, ...parsedDrugScreenStatuses, ...activeFlags]

    const options = generateMultiSelectTagsFilterOptionsList(tagsFilterOptions, combinedParsedFilters)
    setTagsDropdownOptions(options)
    setStoredSelectedTagsList(options)
  }, [searchParams])

  useEffect(() => {
    window.addEventListener('popstate', onCloseFilterSettings)

    return () => {
      window.removeEventListener('popstate', onCloseFilterSettings)
    }
  }, [onCloseFilterSettings])

  const onSetTagsDropdownOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newOptions) => {
      console.log('New Options Selected:', newOptions)
      setTagsDropdownOptions(newOptions)
      setStoredSelectedTagsList(newOptions)

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const selectedOptions = newOptions.filter((option) => option.isActive)
      console.log('Selected Options:', selectedOptions)

      // Categorize selected options by type
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const flags = selectedOptions.filter((option) => option.type === 'flag').map((option) => option.tagTypeId)
      console.log('Flags:', flags)

      const drugScreenStatuses = selectedOptions
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .filter((option) => option.type === 'drugScreen')
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((option) => option.tagTypeId)
      console.log('Drug Screen Statuses:', drugScreenStatuses)

      const identityVerificationStatuses = selectedOptions
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .filter((option) => option.type === 'identityVerification')
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((option) => option.tagTypeId)
      console.log('Identity Verification Statuses:', identityVerificationStatuses)

      // Collect all changes to be made to searchParams
      const newSearchParams = new URLSearchParams(searchParams)
      console.log('Current Search Params before changes:', newSearchParams.toString())

      // Remove existing DrugScreenStatuses and IdentityVerificationStatuses
      ;[filterRowTypeAPI.DRUG_SCREEN_STATUSES, filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES].forEach(
        (filterType) => {
          const regex = new RegExp(`^${filterType}\\[\\d+\\]$`)
          // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
          searchParams.forEach((value, key) => {
            if (regex.test(key)) {
              console.log(`Removing parameter: ${key}`)
              newSearchParams.delete(key)
            }
          })
        },
      )

      // Remove existing flags that are not selected
      tagsFilterOptions
        .filter((option) => option.type === 'flag')
        .forEach((option) => {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (!flags.includes(option.tagTypeId)) {
            console.log(`Removing flag parameter: ${option.id}`)
            newSearchParams.delete(option.id)
          }
        })

      // Set new flags
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      flags.forEach((flag) => {
        console.log(`Setting flag parameter: ${flag} = true`)
        newSearchParams.set(flag, 'true')
      })

      // Set new DrugScreenStatuses
      if (drugScreenStatuses.length > 0) {
        const drugScreenParams = setIndexedParams(filterRowTypeAPI.DRUG_SCREEN_STATUSES, drugScreenStatuses)
        // @ts-expect-error TS2488 -- MIGRATION: not approved, fix when encountered
        Object.entries(drugScreenParams).forEach(([key, value]) => {
          console.log(`Setting parameter: ${key} = ${value}`)
          newSearchParams.set(key, value)
        })
      }

      // Set new IdentityVerificationStatuses
      if (identityVerificationStatuses.length > 0) {
        const identityVerificationParams = setIndexedParams(
          filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES,
          identityVerificationStatuses,
        )
        // @ts-expect-error TS2488 -- MIGRATION: not approved, fix when encountered
        Object.entries(identityVerificationParams).forEach(([key, value]) => {
          console.log(`Setting parameter: ${key} = ${value}`)
          newSearchParams.set(key, value)
        })
      }

      console.log('Updated Search Params:', newSearchParams.toString())

      // Update the searchParams in the URL
      setSearchParams(newSearchParams)

      // Update filterRow based on the new parameters
      const filterRows = []

      // Handle Flags
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      flags.forEach((flag) => {
        filterRows.push(`${flag}=true`)
      })

      // Handle DrugScreenStatuses
      if (drugScreenStatuses.length > 0) {
        filterRows.push(getFilterRowAPI(filterRowTypeAPI.DRUG_SCREEN_STATUSES, drugScreenStatuses))
      }

      // Handle IdentityVerificationStatuses
      if (identityVerificationStatuses.length > 0) {
        filterRows.push(getFilterRowAPI(filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES, identityVerificationStatuses))
      }

      // Combine all filter rows into a single query string
      const apiRequestRow = filterRows.filter(Boolean).join('&')
      console.log('Constructed API Request Row:', apiRequestRow)
      setFilterRow(apiRequestRow)
    },
    [
      setFilterRow,
      setStoredSelectedTagsList,
      searchParams,
      filterRowTypeAPI.DRUG_SCREEN_STATUSES,
      filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES,
      tagsFilterOptions,
      setSearchParams,
      getFilterRowAPI,
    ],
  )

  const onClearFilter = useCallback(() => {
    console.log('Clearing all filters.')

    // Deselect all options in the dropdown
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setTagsDropdownOptions((prev) => prev.map((t) => ({ ...t, isActive: false })))
    setFilterRow('')

    // Create a new URLSearchParams object to modify
    const newSearchParams = new URLSearchParams(searchParams)
    console.log('Current Search Params before clear:', newSearchParams.toString())

    // Remove all flag-type filter parameters
    tagsFilterOptions
      .filter((option) => option.type === 'flag')
      .forEach((option) => {
        if (newSearchParams.has(option.id)) {
          console.log(`Removing flag parameter: ${option.id}`)
          newSearchParams.delete(option.id)
        }
      })

    // Remove all DrugScreenStatuses and IdentityVerificationStatuses
    ;[filterRowTypeAPI.DRUG_SCREEN_STATUSES, filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES].forEach((filterType) => {
      const regex = new RegExp(`^${filterType}\\[\\d+\\]$`)
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      searchParams.forEach((value, key) => {
        if (regex.test(key)) {
          console.log(`Removing parameter: ${key}`)
          newSearchParams.delete(key)
        }
      })
    })

    // Additionally, remove the generic visitTags parameter if it's still being set elsewhere
    if (newSearchParams.has(routeParam.VISIT_TAGS)) {
      console.log(`Removing parameter: ${routeParam.VISIT_TAGS}`)
      newSearchParams.delete(routeParam.VISIT_TAGS)
    }

    console.log('Updated Search Params after clear:', newSearchParams.toString())

    // Update the searchParams in the URL
    setSearchParams(newSearchParams)

    // Clear session storage for tags
    removeStoredSelectedTagsList()
  }, [
    removeStoredSelectedTagsList,
    setFilterRow,
    searchParams,
    tagsFilterOptions,
    filterRowTypeAPI.DRUG_SCREEN_STATUSES,
    filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES,
    routeParam.VISIT_TAGS,
    setSearchParams,
  ])

  return (
    <div className='visit-table-tags-filter-container' ref={ref}>
      <MultiSelectDropdown
        isWithOptionsSort
        isDisabled={loading}
        isFlexible
        isEmptyMessage
        options={tagsDropdownOptions}
        setOptions={onSetTagsDropdownOptions}
        className={classNames('tags-filter-dropdown-visit-table', {
          tableViewUpcoming: tableView === tableViewOptions[0],
        })}
        dropId='tags-filter-dropdown-visit-table-id'
        label={TAGS_FILTER_DROPDOWN_LABEL}
      />
      <SecondaryButton
        btnText={CLEAR_TEXT}
        onPress={onClearFilter}
        id='clear-tags-options-btn'
        className='clear-tags-options-btn-container'
      />
    </div>
  )
})

export default TagsFilter
